import { createContext, useContext, FC, useState, ReactNode } from "react";

import { Layout, Typography } from "antd";

import SidebarMenu from "./SidebarMenu";
import logo from "../../../assets/images/airp_logo.png";
import useDeviceType from "../../../utils/deviceType";

const { Sider } = Layout;
const { Link } = Typography;

interface SidebarContextType {
  collapsed: boolean;
  setCollapsed: (collapsed: boolean) => void;
}

const SidebarContext = createContext<SidebarContextType>({
  collapsed: false,
  setCollapsed: () => {},
});

export const useSidebar = () => useContext(SidebarContext);

export const SidebarProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <SidebarContext.Provider value={{ collapsed, setCollapsed }}>
      {children}
    </SidebarContext.Provider>
  );
};

const Sidebar: FC = () => {
  const { collapsed, setCollapsed } = useSidebar();
  const { isMobile } = useDeviceType();

  const styles: Record<string, React.CSSProperties> = {
    sider: {
      overflow: "auto",
      height: "100vh",
      position: isMobile ? "fixed" : "sticky",
      insetInlineStart: 0,
      top: 0,
      bottom: 0,
      scrollbarWidth: "thin",
      scrollbarGutter: "stable",
      backgroundColor: "#403D39",
      display: isMobile && collapsed ? "none" : "block",
      ...(isMobile && {
        width: "100vw !important",
        minWidth: "100vw !important",
        maxWidth: "100vw !important",
        zIndex: 1000,
      }),
    },
    logoContainer: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    logo: {
      objectFit: "contain",
      marginTop: "20px",
      marginBottom: "20px",
    },
  };

  return (
    <>
      <Sider
        breakpoint="md"
        collapsedWidth={isMobile ? 220 : 0}
        collapsed={collapsed}
        onBreakpoint={(broken) => {
          setCollapsed(broken);
        }}
        onCollapse={(collapsed, _type) => {
          setCollapsed(collapsed);
        }}
        collapsible
        width={isMobile ? "100vw" : 220}
        style={styles.sider}
      >
        <Link style={styles.logoContainer} href="/">
          <img
            src={logo}
            alt="logo"
            width={150}
            height={64}
            style={styles.logo}
          />
        </Link>
        <SidebarMenu />
      </Sider>
    </>
  );
};

export default Sidebar;
